import { sendEventToWebView } from '@src/bridge/bridgeMessenger';
import { useEffect } from 'react';
import { EWebViewEvents } from '@src/bridge';

const useSendPageFinished = ({ isMeetingEnded = false }: { isMeetingEnded?: boolean }) => {
  useEffect(() => {
    if (isMeetingEnded) {
      sendEventToWebView({ eventType: EWebViewEvents.WEB_SHEET_DISMISSED });
      sendEventToWebView({ eventType: EWebViewEvents.MEETING_ENDED });
    }
    sendEventToWebView({ eventType: EWebViewEvents.PAGE_FINISHED });
  }, [isMeetingEnded]);
};

export default useSendPageFinished;
